import { useEffect, useRef, useState } from "react";
import {
  Wrapper,
  Input,
  InputSection,
  Button,
  ChatStepsWrapper,
  ChatTopSpaceSection,
  Loader,
} from "./style";
import { ChatMessage } from "../ChatMessage";
import { VericalScroller } from "../ScrollCursor";

export const ChatWrapper = ({
  conversation,
  onChatMessage,
  loading,
  openModal,
  docHeaderInfo,
}) => {
  const [currentText, setCurrentText] = useState("");
  const ref = useRef();
  const [topMargin, setTopMargin] = useState(
    "calc(var(--window-height) * 0.7)"
  );
  const [scrollAmount, setScrollAmount] = useState(0);
  const topSpaceRef = useRef();
  const initialScroll = useRef(null);
  const scrollDown = () => {
    const newScroll = ref.current.scrollHeight;
    if (!initialScroll.current) initialScroll.current = newScroll;
    const newTopSpaceHeigthRaw = -(
      newScroll -
      initialScroll.current -
      topSpaceRef.current.getBoundingClientRect().height
    );

    setTimeout(() => {
      setTopMargin(
        `${Math.round(newTopSpaceHeigthRaw > 50 ? newTopSpaceHeigthRaw : 50)}px`
      );
    }, 5000);

    ref.current.scroll({
      top: newScroll,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    return () => {
      if (conversation.length && ref?.current) scrollDown();
    };
  }, [conversation]);

  const onUserInputEnd = () => {
    if (!currentText) return;
    onChatMessage(currentText);
    setCurrentText("");
  };
  const onChatScroll = (e) => {
    const totalScrollableAmount =
      ref?.current?.scrollHeight - ref?.current?.clientHeight;
    const currentScroll = e.target.scrollTop;
    setScrollAmount((currentScroll / totalScrollableAmount) * 100);
  };
  return (
    <Wrapper>
      <VericalScroller top={scrollAmount} target={ref} visible={!loading} />
      <ChatStepsWrapper ref={ref} onScroll={onChatScroll}>
        <ChatTopSpaceSection
          ref={topSpaceRef}
          style={{ minHeight: topMargin }}
        />
        {conversation.map(({ text, left, references, body }, index) => (
          <ChatMessage
            onLoad={() => scrollDown()}
            left={left}
            loading={false}
            body={body || text}
            last={index === conversation.length - 1}
            key={index}
            {...{ references, docHeaderInfo, openModal }}
          />
        ))}
      </ChatStepsWrapper>
      <InputSection>
        <Input
          value={currentText}
          onLoad={() => scrollDown()}
          onChange={(e) => setCurrentText(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              onUserInputEnd();
            }
          }}
          style={{
            width: `${currentText.length > 40 ? currentText.length - 1 : 30}ch`,
          }}
        />
        <Button onClick={onUserInputEnd}>{">"}</Button>
        <Loader style={{ opacity: loading ? 1 : 0 }} />
      </InputSection>
      {false ? (
        <pre
          style={{
            position: "fixed",
            top: "2vh",
            zIndex: 100,
            color: "red",
            fontSize: "1vw",
            backgroundColor: "rgba(255,255,255,0.7)",
          }}
        >
          {JSON.stringify({ loading }, null, "\t")}
        </pre>
      ) : (
        ""
      )}
    </Wrapper>
  );
};
